var map = {
	"./common-section-animation.js": 9138,
	"./contacts-section.js": 4011,
	"./home-page-header.js": 3400,
	"./internal-page-banner.js": 6652,
	"./news-and-companies-filters.js": 8112,
	"./strategy-and-numbers-common.js": 8575,
	"./strategy.js": 5149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7417;